import { Component, computed, effect, inject, signal } from '@angular/core'
import { HospitalPricingService } from '../hospital-pricing.service'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { distinctUntilChanged, map, tap } from 'rxjs'
import { AppPractice } from 'src/app/shared/services/ppv.api'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
   selector: 'vc-vetcor-pricing-admin-hospital',
   templateUrl: './vetcor-pricing-admin-hospital.component.html',
   styleUrl: './vetcor-pricing-admin-hospital.component.scss',
   standalone: false,
})
export class VetcorPricingAdminHospitalComponent {
   userServices = inject(AuthManager)
   pricingService = inject(HospitalPricingService)
   hospitalPrices = this.pricingService.hospitalPrices
   activeCycle = this.pricingService.activeCycle
   firstHm = computed(() => (this.practice()?.hMs?.length > 0 ? this.practice()?.hMs[0] : null))

   isReadOnly = signal<boolean>(false)
   selectedPracticeSKey = signal<number>(undefined)
   practice = this.pricingService.activePractice
   showOnlyUnreviewedProducts = signal<boolean>(false)

   constructor(private route: ActivatedRoute) {
      route.paramMap
         .pipe(
            map((pm) => Number(pm.get('practiceSKey'))),
            distinctUntilChanged(),
            tap((practiceSKey) => {
               this.selectedPracticeSKey.set(practiceSKey)
            })
         )
         .subscribe()

      effect(() => {
         const user = this.userServices.user()
         user?.roles.forEach((role) => {
            if (role.roleName == 'PricingManagerReadOnly') {
               this.isReadOnly.set(true)
            }
         })

         this.pricingService.loadHospitalPrices(this.selectedPracticeSKey())
      })

      this.userServices.getCurrentUser().subscribe()
   }

   approveAllPricingUpdateRequests(): void {
      setTimeout(() => document.getElementById('approveAllSureButton')?.click(), 100)
   }

   rejectAllPricingUpdateRequests(): void {
      setTimeout(() => document.getElementById('rejectAllSureButton')?.click(), 100)
   }

   approveAllPricingUpdateRequests_finalize(): void {
      this.pricingService.approveRemainingPricingUpdateRequests(this.pricingService.activeCycle().batchId)
   }

   rejectAllPricingUpdateRequests_finalize(): void {
      this.pricingService.rejectRemainingPricingUpdateRequests(this.pricingService.activeCycle().batchId)
   }

   getStatusBackgroundColorClass(value: number): string {
      if (value == 1) {
         return 'status-good'
      } else if (value >= 0.6) {
         return 'status-weak'
      } else if (value >= 0.1) {
         return 'status-poor'
      } else {
         return 'not-begun'
      }
   }
}
